// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('analysis.pdfTemplate', {
        url: '/pdfTemplate',
        templateUrl: 'main/analysis/pdfTemplate/pdfTemplate.tpl.html',
        controller: 'AnalysisPdfTemplateController as vm',
        resolve: {
        }
    });
}

// @ngInject
function AnalysisPdfTemplateController(AnalysisApiService, ToasterService, loadSpinnerService) {
    var vm = this;

    // properties
    vm.templates = [];
    vm.selectedTemplate = {};

    //initialize
    loadSpinnerService.start('pdfTemplate');
    AnalysisApiService.getPdfTemplates().then(function (data) {
            vm.templates = data;
            vm.selectedTemplate = _.head(vm.templates);
        },
        function (error) {
            ToasterService.showError(error, "");
        })
        .finally(function () {
            loadSpinnerService.stop('pdfTemplate');
    });

    // functions
    vm.selectTemplate = selectTemplate;
    vm.save = save;

    function selectTemplate(template) {
        vm.selectedTemplate = template;
    }

    function save() {
        loadSpinnerService.start('pdfTemplate');
        AnalysisApiService.savePdfTemplate(angular.copy(vm.selectedTemplate)).then(function (response) {
            ToasterService.showSuccess("", "");
        },
        function (error) {
            ToasterService.showError(error, "");
        })
        .finally(function () {
            loadSpinnerService.stop('pdfTemplate');
        });
    }
}

angular.module('analysis.pdfTemplate', [])
    .config(stateConfig)
    .controller('AnalysisPdfTemplateController', AnalysisPdfTemplateController);
